type SessionData = Record<string,any>
type InputType = 'text' | 'audio' | 'image'
type Input     = {type: InputType, content: string}
type Output    = {json: Object|null, text: string}
type Review    = { sender: string, rating: number, comment?: string }
type Attachment= {uid: string, type: string, title: string, content: string, path: string}
type Exchange  = {uid: string, input?: Input, output?: Output, attachments?: Attachment[], timestamp: string|Date, status?: string, review?: Review}
type ChunkType = 'start' | 'error' | 'searching' | 'thinking' | 'topic' | 'attachments' | 'data' | 'token'
type Chunk     = {uid: string, type: ChunkType,  data: any, last: boolean }
type Session = {uid: string, status: string, owner: string, application: string, dialog: Array<Exchange>, data?: SessionData}

export class TIAmie {
    app: string = ''
    sid: string = ''
    data: SessionData = {}
    host: string = ''

    constructor(app: string, data: SessionData = {}, host: string='') {
        this.app = app 
        this.data = data || {}
        this.host = host || ''
    }

    private async loadSession(sid: string) : Promise<Session|null> {
        var session: Session|null = null
        try {
            if(!this.app) throw new Error('no app specified..')
            const url = `${this.host}/apps/${this.app}/chat/${sid}`
            const response = await fetch(url)
            if(!response.ok) throw new Error(`HTTP error! status: ${response.status}`) 
            const body:Record<string,any> = await response.json()
            if(!body?.uid) throw new Error('no session uid obtained..')
            this.sid = body.uid 
            console.log('session', body)
            session = { 
                uid: body.uid,
                status: body.status,
                owner: body.owner,
                application: body.application,
                dialog: body.dialog || {},
                data: body.data || {}
            } 
        }
        catch(e:any) { console.error('error starting a session :', e.message) }
        finally  { return session}
    }

    private async startSession() : Promise<Session|null> {
        var session: Session|null = null
        try {
            if(!this.app) throw new Error('no app specified..')
            const url = `${this.host}/apps/${this.app}/chat`
            const payload = {
                method: "POST",
                headers: {"Content-Type": "application/json", "Accept": "application/json"},
                body: JSON.stringify(this.data)
            }
            const response = await fetch(url, payload)
            if(!response.ok) throw new Error(`HTTP error! status: ${response.status}`) 
            const body:Record<string,any> = await response.json()
            if(!body?.uid) throw new Error('no session uid obtained..')
            this.sid = body.uid 
            console.log('session', body)
            session = { 
                uid: body.uid,
                status: body.status,
                owner: body.owner,
                application: body.application,
                dialog: body.dialog || {},
                data: body.data || {}
            } 
        }
        catch(e:any) { console.error('error starting a session :', e.message) }
        finally  { return session}
    }

    public async start(sid?: string|null) : Promise<Session|null> {
        return sid ? this.loadSession(sid) : this.startSession()
    } 

    async ask(q: string, onChunk: (chunk: Chunk) => void, onDone: () => void, onError ? : (error: any) => void) : Promise<void> {
        try {
            if(!this.sid) throw new Error('no session opened..')
            const url = `${this.host}/apps/${this.app}/chat/${this.sid}`
            const payload = {
                method: "POST",
                headers: {"Content-Type": "application/json", "Accept": "application/json"},
                body: JSON.stringify({type: 'text', content: q})
            }
            const response = await fetch(url, payload)
            if(!response.ok || !response.body) throw new Error(`HTTP error ! ${response.status}`)

            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');

            let buffer = '';

            while (true) {
                const {done, value} = await reader.read()
                if (done) break

                buffer += decoder.decode(value, { stream: true })
                const lines = buffer.split('\n').filter(line => line.trim() !== '')
                console.dir(lines)
                
                var unparsed = ''
                for (const line of lines) {
                    const data = line.replace('data:', '').trim();

                    if (data === '[DONE]') {
                        if(onDone)  onDone()
                        return
                    }

                    try {
                        const chunk = JSON.parse(data)
                        if(onChunk) onChunk(chunk)
                    } 
                    catch (e:any) { unparsed += line; /** console.error('Parse error:', e.message, 'Line:', line) */ }
                }
                buffer = unparsed
            }
            if(onDone)  onDone()
        } 
        catch (e:any) {
            console.error('error sending input :', e.message)
            if (onError) onError(e)
        }
    }
}

import { TConversation } from '../vxc_conversation'

function addInput(q: string) {
    console.log('sending input', q)
    let conversation: TConversation = document.getElementById('conversation') as TConversation
    if(conversation) 
        conversation.createExchange({type: 'text', content: q})
    else console.error('conversation viewer not found')
} 

function processChunk(chunk:any) {
    // console.log('got Chunk', chunk)
    let conversation: TConversation = document.getElementById('conversation') as TConversation
    if(conversation) 
        conversation.addChunk(chunk)
    else console.error('conversation viewer not found')
}

async function test() {
    const qs = ['Comment faire une tarte aux pommes ?', 'et un flan ?']
    const iamie = new TIAmie('aac9b6d4-baf8-44bd-99ac-7e0e738413dc')
    iamie.host = 'http://localhost:7223'
    var started = await iamie.start()
    console.log('started :', started)
    console.dir(iamie)
    
    for(let q of qs) {
        addInput(q)
        await iamie.ask(q, (chunk) => processChunk(chunk), () => console.log('done'), (e) => console.error(e) )
        console.log('------(done)---------')
    }
}
// test()